// extracted by mini-css-extract-plugin
module.exports = {"article":"styles_article__JnalJ","fadeInOut":"styles_fadeInOut__2Gj3H","loader":"styles_loader__TyRH_"};